/**
 * Transforma la respuesta de categorias/servicios del API al formato
 * que esperan OurServicesPrices y OurServicesSlug.
 */

const bgColors = ['card1', 'card2', 'card3', 'card4', 'card5', 'card6'];

// Fallback images when API doesn't provide one, keyed by normalised category name
const FALLBACK_IMAGES = {
  'beauty makeup': '/assets/paomakeup/images/services/service-makeup.jpeg',
  'permanent makeup': '/assets/paomakeup/images/services/microblading.jpg',
  'maquillaje semipermente': '/assets/paomakeup/images/services/microblading.jpg',
  'beauty lashes & brows': '/assets/paomakeup/images/services/beauty-lashes.jpg',
  'beauty hair': '/assets/paomakeup/images/services/service-salon.jpeg',
  'beauty face & body': '/assets/paomakeup/images/services/beauty-face.jpg',
  'beauty nails': '/assets/paomakeup/images/services/service-beauty-nails.jpg',
};

function resolveImage(category) {
  if (category.image_url) return category.image_url;
  if (category.image) return category.image;
  const key = (category.name || '').toLowerCase().trim();
  return FALLBACK_IMAGES[key] || '';
}

export function mapCategoriesToPriceData(categories) {
  if (!categories || !Array.isArray(categories)) return [];

  return categories.map((category, index) => ({
    service_name: category.name || '',
    service_slug: category.slug || String(category.id || ''),
    service_image: resolveImage(category),
    bgcolor: bgColors[index % bgColors.length],
    sub_services: mapSubServices(category.children || category.sub_categories || []),
    services: mapServices(category.services || []),
  }));
}

function mapSubServices(children) {
  if (!children || !Array.isArray(children) || children.length === 0) return undefined;

  return children.map((child) => ({
    sub_service_name: child.name || '',
    description: child.description || '',
    services: mapServices(child.services || []),
  }));
}

function mapServices(services) {
  if (!services || !Array.isArray(services)) return [];

  return services.map((service) => {
    const id = service.id ?? service.service_id ?? service.pivot?.service_id ?? null;
    if (!id) {
      console.warn('[dataMappers] Service missing id:', JSON.stringify(service));
    }
    return {
      id,
      name: service.name || service.service_name || '',
      price: service.price ? `RD$ ${Number(service.price).toLocaleString()}` : '',
    };
  });
}

/**
 * Transforma categorias del API al formato que espera OurServices (listado de tarjetas).
 */
export function mapCategoriesToServiceCards(categories) {
  if (!categories || !Array.isArray(categories)) return [];

  return categories.map((category) => ({
    title: category.name || '',
    service_slug: category.slug || String(category.id || ''),
    description: category.description || '',
    image: resolveImage(category),
  }));
}
